import { ChangeDetectorRef, Component } from "@angular/core";
import { CommonModule, NgFor, NgIf } from "@angular/common";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { ModalComponent } from "app/modules/shared/modal.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseAlertComponent } from "@fuse/components/alert";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { MyToastrService } from "app/_services/toastr.service";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { AllPartnersComponent } from "../all-partners/all-partners.component";
import { CancelledPartnersComponent } from "../cancelled-partners/cancelled-partners.component";
import { PaidPartnersComponent } from "../paid-partners/paid-partners.component";
import { PlanPartnersComponent } from "../plan-partners/plan-partners.component";
import { SuspendedPartnersComponent } from "../suspended-partners/suspended-partners.component";
import { TrialPartnersComponent } from "../trial-partners/trial-partners.component";

@Component({
  selector: "app-partner-management",
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    AllPartnersComponent,
    CancelledPartnersComponent,
    PaidPartnersComponent,
    PlanPartnersComponent,
    SuspendedPartnersComponent,
    TrialPartnersComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: "./partner-management.component.html",
  styleUrls: ["./partner-management.component.scss"],
})
export class PartnerManagementComponent {
  selectedIndex: number = 0;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  constructor(
    public _cs: CommonService,
    private _lS: LoaderService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _bs: BaseRequestService,
    private _ds: DynamicSettingsService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService
  ) {
    this._cs.selectedSiteChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((cmp: any) => {
        this.tabFn(this.selectedIndex);
        this._changeDetectorRef.markForCheck();
      });
  }
  ngOnInit(): void {
    // let tabValue = (this._cs.tabCheck) ? this._cs.tabCheck : 0;
    // if (this._cs.tabCheck)
      setTimeout(() => {
        this.tabFn(0);
      }, 1000);
  }
  tabFn($event: any): void {
    this.selectedIndex = $event;
    if ($event === 0) {
      this._ds.partnerTabEmitter.emit("app-all-partners");
    }
    if ($event === 1) {
      this._ds.partnerTabEmitter.emit("app-trial-partners");
    }
    if ($event === 2) {
      this._ds.partnerTabEmitter.emit("app-plan-partners");
    }
    if ($event === 3) {
      this._ds.partnerTabEmitter.emit("app-paid-partners");
    }
    if ($event === 4) {
      this._ds.partnerTabEmitter.emit("app-suspended-partners");
    }
    if ($event === 5) {
      this._ds.partnerTabEmitter.emit("app-cancelled-partners");
    }
  }
}
